import React from "react";

const LandingErrorComponent: React.FC<{}> = (props: {}) => {
    //TODO Implement it
    return <>
        <h1> There is an error here </h1>
    </>;
}

export default LandingErrorComponent